import {
  GET_COMBO_LOAI_TAI_SAN,
  GET_COMBO_LOAI_TAI_SAN_SUCCESS,
  GET_COMBO_LOAI_TAI_SAN_FAILURE,
  POST_LOAI_TAI_SAN_TM,
  POST_LOAI_TAI_SAN_TM_SUCCESS,
  POST_LOAI_TAI_SAN_TM_FAILURE,
  SHOW_MODAL_LOAI_TAI_SAN,
} from "./actionTypes";

export const getComboLoaiTaiSan = (dataSearch) => ({
  type: GET_COMBO_LOAI_TAI_SAN,
  dataSearch,
});

export const getComboLoaiTaiSanSuccess = (data) => ({
  type: GET_COMBO_LOAI_TAI_SAN_SUCCESS,
  payload: data,
});

export const getComboLoaiTaiSanFailure = () => ({
  type: GET_COMBO_LOAI_TAI_SAN_FAILURE,
});

export const postLoaiTaiSan = (dataPost) => ({
  type: POST_LOAI_TAI_SAN_TM,
  dataPost,
});

export const postLoaiTaiSanSuccess = (data) => ({
  type: POST_LOAI_TAI_SAN_TM_SUCCESS,
  payload: data,
});

export const postLoaiTaiSanFailure = () => ({
  type: POST_LOAI_TAI_SAN_TM_FAILURE,
});

export const showModalLoaiTaiSan = (dataPost) => ({
  type: SHOW_MODAL_LOAI_TAI_SAN,
  dataPost,
});
